import {
  PostPostsResponse,
  PutPostsResponse,
  GetPostsByUUIDResponse,
  GetPostResponse,
  GetPostsItemResponse,
} from '@/services/response/posts';
import { Posts } from '@/model/posts';

export class PostsConverter {
  static toDomainFromGetPostItemResponse(response: GetPostsItemResponse): Posts {
    return {
      uuid: response.uuid,
      content: response.content,
      identifier: response.identifier,
      status: response.status,
      disable_comments: response.disable_comments,
      enable_home: response.enable_home,
      total_likes: response.total_likes,
      total_comments: response.total_comments,
      posts_media: response.posts_media.map(media => ({
        uuid: media.uuid,
        image_url: media.image_url ?? '',
      })),
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPostsPaginatedResponse(response: GetPostResponse): Posts[] {
    return response.data.map(PostsConverter.toDomainFromGetPostItemResponse);
  }

  static toDomainFromPostItemResponse(response: PostPostsResponse): Posts {
    return {
      uuid: response.uuid,
      content: response.content,
      identifier: response.identifier,
      status: response.status,
      disable_comments: response.disable_comments,
      enable_home: response.enable_home,
      total_likes: response.total_likes,
      total_comments: response.total_comments,
      posts_media: response.posts_media.map(media => ({
        uuid: media.uuid,
        image_url: media.image_url ?? '',
      })),
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutPostsResponse(response: PutPostsResponse): Posts {
    return {
      uuid: response.uuid,
      content: response.content,
      identifier: response.identifier,
      status: response.status,
      disable_comments: response.disable_comments,
      enable_home: response.enable_home,
      total_likes: response.total_likes,
      total_comments: response.total_comments,
      posts_media: response.posts_media.map(media => ({
        uuid: media.uuid,
        image_url: media.image_url ?? '',
      })),
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromGetPostsByUUIDResponse(response: GetPostsByUUIDResponse): Posts {
    return {
      uuid: response.uuid,
      content: response.content,
      identifier: response.identifier,
      status: response.status,
      disable_comments: response.disable_comments,
      enable_home: response.enable_home,
      total_likes: response.total_likes,
      total_comments: response.total_comments,
      posts_media: response.posts_media.map(media => ({
        uuid: media.uuid,
        image_url: media.image_url ?? '',
      })),
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
